export default __webpack_public_path__ + "static/media/standup.5d98e4c4.JPG";